// Hero: navn, org.nr, adresse, stiftet, næring + status-badge (konkurs / avvikling).
import { Skeleton } from "@/components/ui/skeleton";
import { yearOf } from "../api/format";
import type { BrregEnhet } from "../api/types";

interface HeroCardProps {
  enhet: BrregEnhet | null | undefined;
  isLoading: boolean;
}

/** Status-badge-tekst fra de boolske flaggene; null når selskapet er ordinært. */
function statusLabel(e: BrregEnhet): string | null {
  if (e.konkurs) return "Konkurs";
  if (e.underTvangsavvikling) return "Under tvangsavvikling";
  if (e.underAvvikling) return "Under avvikling";
  return null;
}

export function HeroCard({ enhet, isLoading }: HeroCardProps) {
  if (isLoading) {
    return (
      <div className="glass mb-[18px] px-[30px] py-[26px]">
        <Skeleton className="h-9 w-72 bg-[rgba(120,60,10,0.12)]" />
        <Skeleton className="mt-3 h-4 w-96 bg-[rgba(120,60,10,0.1)]" />
      </div>
    );
  }

  if (!enhet) {
    return (
      <div className="glass mb-[18px] px-[30px] py-[26px]">
        <h1 className="m-0 text-[34px] font-bold tracking-[-0.02em] text-[var(--ink)]">
          Ukjent selskap
        </h1>
        <p className="mt-2 text-[13.5px] text-[var(--sub)]">
          Fant ingen enhet i Enhetsregisteret for dette org.nr.
        </p>
      </div>
    );
  }

  const sub = [
    `Org. ${enhet.organisasjonsnummer}`,
    [enhet.adresse, [enhet.postnummer, enhet.poststed].filter(Boolean).join(" ")]
      .filter(Boolean)
      .join(", "),
    yearOf(enhet.stiftelsesdato) ? `Stiftet ${yearOf(enhet.stiftelsesdato)}` : null,
    enhet.naering,
  ].filter(Boolean);

  const status = statusLabel(enhet);

  return (
    <div className="glass mb-[18px] px-[30px] py-[26px]">
      <h1 className="m-0 text-[34px] font-bold tracking-[-0.02em] text-[var(--ink)]">
        {enhet.navn}
      </h1>
      <div className="tab-num mt-[9px] text-[13.5px] text-[var(--sub)]">
        {sub.join("  ·  ")}
      </div>
      {status && (
        <span className="status mt-[15px]">
          <span className="dot" />
          {status}
        </span>
      )}
    </div>
  );
}
